import { removeInvisibleChar } from "src/utils/string.utils";

export function ActionStatus({ title, color }: { title: string; color: string }) {
  return (
    <div
      className="flex space-x-2.5 items-center"
      style={{ color: title === "Не начато" ? "#637381" : removeInvisibleChar(color.trim()) }}
    >
      <span className="rounded-full w-2.5 h-2.5" style={{ backgroundColor: removeInvisibleChar(color.trim()) }}></span>
      <span>{title}</span>
    </div>
  );
}
